import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, Injectable } from '@angular/core';
import {  MatDialog } from '@angular/material';
import { DataApi } from 'app/Model/dataApi';
import { DataApiService } from 'app/services/data-api.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { BehaviorSubject, EMPTY, Observable, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CambioCredencialComponent } from './cambio-credencial/cambio-credencial.component';



// @Component({
//   selector: 'app-modal',
//   template: `
//     <h2 mat-dialog-title>{{ data.title }}</h2>
//     <mat-dialog-content>
//       <p>{{ data.message }}</p>
//     </mat-dialog-content>
//     <mat-dialog-actions align="end">
//       <button mat-button mat-dialog-close>Entendido</button>
//     </mat-dialog-actions>
//   `,
//   styles: [
//     `
//       mat-dialog-content {
//         font-size: 16px;
//       }
//       mat-dialog-actions {
//         margin-top: 15px;
//       }
//     `,
//   ],
// })

@Injectable({
  providedIn: 'root'
})
export class EstudianteFacadeService {

  constructor(
    public _toast: ToastrServiceLocal,
    public _dataApi: DataApiService,
    public _mensajesHttp: MensajesHttpService
    // public dialogRef: MatDialogRef<CambioCredencialComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
    )
    { }

    //Respuesta Acción
    private Action$ = new Subject<any>();
    public responseAction$: Observable<any> = this.Action$.asObservable();

    private Cargando$ = new BehaviorSubject<boolean>(false);
    public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

    private Error$ = new BehaviorSubject<any>({ hasError: false, recurso: '', messageError: '', errors: [] });
    public responseError$: Observable<any> = this.Error$.asObservable();

    private Estudiante$ = new BehaviorSubject<any[]>([]);
    public responseEstudiante$: Observable<any[]> = this.Estudiante$.asObservable();

    public ViewAsignaturas$ = new BehaviorSubject<any[]>([]);
    public responseViewAsignaturas$: Observable<any[]> = this.ViewAsignaturas$.asObservable();

    public cambioContraseña$ = new BehaviorSubject<any[]>([]);
    public responsecambioContraseña$: Observable<any[]> = this.cambioContraseña$.asObservable();

    public VerHistorialAcademico$ = new BehaviorSubject<any[]>([]);
    public responseVerHistorialAcademico$: Observable<any[]> = this.VerHistorialAcademico$.asObservable();

    public CertificacionEgreso$ = new BehaviorSubject<any[]>([]);
    public responseCertificacionEgreso$: Observable<any[]> = this.CertificacionEgreso$.asObservable();

    public SolicitudesHistorialAcademico$ = new BehaviorSubject<any[]>([]);
    public responseSolicitudesHistorialAcademico$: Observable<any[]> = this.SolicitudesHistorialAcademico$.asObservable();

    public MisSolicitudesHistorial$ = new BehaviorSubject<any[]>([]);
    public responseMisSolicitudesHistorial$: Observable<any[]> = this.MisSolicitudesHistorial$.asObservable();

    public MisSolicitudesCertificacion$ = new BehaviorSubject<any[]>([]);
    public responseMisSolicitudesCertificacion$: Observable<any[]> = this.MisSolicitudesCertificacion$.asObservable();

    // open(data: { title: string; message: string }) {
    //   this.dialog.open(CambioCredencialComponent, {
    //     data,
    //     width: '400px',
    //   });
    // }

    // mostrarInformacionEstudiante(Estudiante: any ,params: any): Observable<any> {
    //   console.log("prueba",Estudiante)
    //   this.Cargando$.next(true);
    //   const request$ = this._dataApi.GetDataApi(`Student/Estudiante/${Estudiante}`, params).pipe(
    //     tap((result: DataApi | any) => {
    //       this.Estudiante$.next(result.data.Table0);
    //       this.Cargando$.next(false);
    //     }),
    //     catchError((error: HttpErrorResponse) => {
    //       console.log(error)
    //       this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un erro al mostrar las promociones', '');
    //       this.Cargando$.next(false);
    //       this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un erro al mostrar las promociones'), errors: [] });
    //       return EMPTY;
    //     })
    //   );

    //   return request$; // Devuelve el observable
    // }

// *** para forma003 ***

    ViewAsignaturasEstudiante(idEstud: any, idPromo: any, numBlock: any ,params: any): Observable<any> {
      this.Cargando$.next(true);
      const request$ = this._dataApi.GetDataApi(`Student/ViewAsignaturasForma03/${idEstud}/${idPromo}/${numBlock}`, params).pipe(
        tap((result: DataApi | any) => {
          // this.AsignaturasStudent$.next(result.data.Table0);
          this.ViewAsignaturas$.next(result.data.Table0);
          this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
          console.log(error)
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un erro al mostrar las promociones', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un erro al mostrar las promociones'), errors: [] });
          return EMPTY;
        })
      );

      return request$; // Devuelve el observable
    }

    cambioCredencialEstudiante(params: any): Observable<any> {
      this.Cargando$.next(true);
      const request$ = this._dataApi.PostDataApi(`Student/cambioPasswordStudent`, params).pipe(
        tap((result: DataApi | any) => {
          // this.AsignaturasStudent$.next(result.data.Table0);
          this.cambioContraseña$.next(result.data.Table0);
          this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
          console.log(error)
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al cambiar credenciales', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un erro al mostrar las promociones'), errors: [] });
          return EMPTY;
        })
      );

      return request$; // Devuelve el observable
    }


    // ------------certificacion egreso
    obtenerCertificacionEgreso(params: any): Observable<any> {
      this.Cargando$.next(true);
      const request$ = this._dataApi.GetDataApi(`Student/CertificacionEgreso`, params).pipe(
        tap((result: DataApi | any) => {
          this.CertificacionEgreso$.next(result.data.Table0);
          this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al obtener la certificación de egreso', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al obtener la certificación de egreso'), errors: [] });
          return EMPTY;
        })
      );
      return request$;
    }

    // ------------solicitud historial academico
    obtenerSolicitudesHistorialAcademico(params: any): Observable<any> {
      this.Cargando$.next(true);
      const request$ = this._dataApi.GetDataApi(`Student/SolicitudHistorialAcademico`, params).pipe(
        tap((result: DataApi | any) => {
          this.SolicitudesHistorialAcademico$.next(result.data.Table0);
          this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al obtener las solicitudes de historial académico', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al obtener las solicitudes'), errors: [] });
          return EMPTY;
        })
      );
      return request$;
    }

    crearSolicitudHistorialAcademico(params: any): void {
      this.Cargando$.next(true);
      this._dataApi.PostDataApi(`Student/SolicitudHistorialAcademico`, params).pipe(
        tap((result: DataApi | any) => {
          this.Cargando$.next(false);
          this._toast.mensajeSuccess('Solicitud enviada correctamente', '');
          this.obtenerSolicitudesHistorialAcademico('').subscribe();
        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al enviar la solicitud', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al enviar la solicitud'), errors: [] });
          return EMPTY;
        })
      ).subscribe();
    }

    // ------------generación de documentos PDF oficiales
    generarHistorialPDF(params: any): Observable<any> {
      this.Cargando$.next(true);
      const request$ = this._dataApi.PostDataApi(`Student/GenerarDocumentos/Historial`, params).pipe(
        tap((result: DataApi | any) => {
          this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al generar el historial académico', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Error al generar historial'), errors: [] });
          return EMPTY;
        })
      );
      return request$;
    }

    generarCertificacionPDF(params: any): Observable<any> {
      this.Cargando$.next(true);
      const request$ = this._dataApi.PostDataApi(`Student/GenerarDocumentos/Certificacion`, params).pipe(
        tap((result: DataApi | any) => {
          this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al generar la certificación de egreso', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Error al generar certificación'), errors: [] });
          return EMPTY;
        })
      );
      return request$;
    }

    // ------------solicitudes PDF generadas por tipo
    getMisSolicitudesHistorial(): Observable<any> {
      const request$ = this._dataApi.GetDataApi(`Student/GenerarDocumentos/MisSolicitudes/HISTORIAL`, '').pipe(
        tap((result: DataApi | any) => {
          this.MisSolicitudesHistorial$.next(result?.data?.solicitudes || []);
        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Error al obtener solicitudes de historial', '');
          return EMPTY;
        })
      );
      return request$;
    }

    getMisSolicitudesCertificacion(): Observable<any> {
      const request$ = this._dataApi.GetDataApi(`Student/GenerarDocumentos/MisSolicitudes/CERTIFICACION`, '').pipe(
        tap((result: DataApi | any) => {
          this.MisSolicitudesCertificacion$.next(result?.data?.solicitudes || []);
        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Error al obtener solicitudes de certificación', '');
          return EMPTY;
        })
      );
      return request$;
    }

    // ------------re-descarga de documento ya generado desde S3
    descargarDocumentoPDF(s3Key: string): Observable<any> {
      return this._dataApi.GetDataApi(
        `Student/GenerarDocumentos/DescargarPDF?s3Key=${encodeURIComponent(s3Key)}`, ''
      ).pipe(
        catchError((error: HttpErrorResponse) => {
          this._mensajesHttp.mostrarErrorHttp(error, 'Error al obtener el enlace de descarga', '');
          return throwError(() => error);
        })
      );
    }

    // ------------verificación de pago en banco antes de generar documento (paso 3 → 4)
    verificarPagoHistorial(comprobante: string): Observable<any> {
      this.Cargando$.next(true);
      return this._dataApi.GetDataApi(`Student/HistoriaAcademico/VerificarComprobante/${comprobante}`, '').pipe(
        tap(() => this.Cargando$.next(false)),
        catchError((error: HttpErrorResponse) => {
          this.Cargando$.next(false);
          return throwError(() => error);
        })
      );
    }

    verificarPagoCertificacion(comprobante: string): Observable<any> {
      this.Cargando$.next(true);
      return this._dataApi.GetDataApi(`Student/CertificacionEgreso/VerificarComprobante/${comprobante}`, '').pipe(
        tap(() => this.Cargando$.next(false)),
        catchError((error: HttpErrorResponse) => {
          this.Cargando$.next(false);
          return throwError(() => error);
        })
      );
    }

    // ------------validación de comprobante antes de avanzar al paso 3
    validarComprobanteHistorial(comprobante: string): Observable<any> {
      this.Cargando$.next(true);
      return this._dataApi.GetDataApi(`Student/HistoriaAcademico/ValidarComprobante/${comprobante}`, '').pipe(
        tap(() => this.Cargando$.next(false)),
        catchError((error: HttpErrorResponse) => {
          this.Cargando$.next(false);
          return EMPTY;
        })
      );
    }

    validarComprobanteCertificacion(comprobante: string): Observable<any> {
      this.Cargando$.next(true);
      return this._dataApi.GetDataApi(`Student/CertificacionEgreso/ValidarComprobante/${comprobante}`, '').pipe(
        tap(() => this.Cargando$.next(false)),
        catchError((error: HttpErrorResponse) => {
          this.Cargando$.next(false);
          return EMPTY;
        })
      );
    }

    // ------------comprobante de pago disponible automáticamente (paso 1 → 2)
    comprobantesDisponiblesHistorial(): Observable<any> {
      return this._dataApi.GetDataApi(`Student/HistoriaAcademico/ComprobantesDisponibles`, '').pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        })
      );
    }

    comprobantesDisponiblesCertificacion(): Observable<any> {
      return this._dataApi.GetDataApi(`Student/CertificacionEgreso/ComprobantesDisponibles`, '').pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        })
      );
    }

    // ------------historial academico
        verHistoriaAcademico(params: any): Observable<any> {
      this.Cargando$.next(true);
      const request$ = this._dataApi.GetDataApi(`Student/HistoriaAcademico`, params).pipe(
        tap((result: DataApi | any) => {
          this.VerHistorialAcademico$.next(result.data.Table0);
          this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
          console.log(error)
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un erro al mostrar las promociones', '');
          this.Cargando$.next(false);
          this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un erro al mostrar las promociones'), errors: [] });
          return EMPTY;
        })
      );

      return request$;
    }


}
